/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { roundValueToPrecision } from '@/components/Rating/utils';
import { type ReviewStatisticResponse } from '@/features/customReviews';
import { type ReviewStatisticsAnalytics } from '../../customReviews/interface/types';

export const reviewAnalyticsSelector = (
  reviews: ReviewStatisticResponse[],
): ReviewStatisticsAnalytics => {
  const productAverageRating: Array<string | null> = [];
  const productReviewCount: Array<string | null> = [];

  reviews.forEach((reviewStatistic) => {
    const averageRating = reviewStatistic.averageOverallRating
      ? roundValueToPrecision(Number(reviewStatistic.averageOverallRating), 0.1).toString()
      : '';

    const totalReviewCount = reviewStatistic.totalReviewCount
      ? reviewStatistic.totalReviewCount
      : '';

    productAverageRating.push(averageRating);
    productReviewCount.push(totalReviewCount);
  });

  return {
    productAverageRating,
    productReviewCount,
  };
};
